<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >

    <b-row>
      <b-col cols="9">
        <b-card title="Installation Data">
          <!-- Device -->
          <b-row>
            <b-col cols="4">
              <b-form-group label="Device" label-for="v-Device">
                <validation-provider #default="{ errors }"  name="Device" rules="required">
                  <v-select readonly id="v-Device" v-model="form.select_1" placeholder="Chose Device" disabled autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="DeviceOptions" :reduce="DeviceOptions => DeviceOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Site -->
            <b-col cols="5">
              <b-form-group label="Site" label-for="v-Site">
                <validation-provider #default="{ errors }"  name="Site" rules="required">
                  <v-select disabled id="v-Site" v-model="form.select_9" placeholder="Chose  Site" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="SiteOptions" :reduce="SiteOptions => SiteOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-form-group
                label="Installation Date"
              >
                <flat-pickr
                  v-model="form.date_1"
                  class="form-control"
                  :config="{ dateFormat: 'd-m-Y'}"
                  placeholder="DD-MM-YYYY"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Device Type" label-for="v-Device Type">
                <validation-provider #default="{ errors }"  name="Device Type">
                  <b-form-input readonly id="v-Device Type" :state="errors.length > 0 ? false:null" v-model="device_type_name" placeholder="Device Type" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Device SN" label-for="v-Device SN">
                <validation-provider #default="{ errors }"  name="Device SN">
                  <b-form-input readonly id="v-Device SN" :state="errors.length > 0 ? false:null" v-model="device_serial_number" placeholder="Device SN" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Device Note" label-for="v-Device Note">
                <validation-provider #default="{ errors }"  name="Device Note">
                  <b-form-input readonly id="v-Device Note" :state="errors.length > 0 ? false:null" v-model="device_note" placeholder="Device Note" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <hr>
              <div id="map" style="height: 300px;"></div>
              <hr>
              <b-row>
                <!-- Latitude -->
                <b-col cols="4">
                  <b-form-group label="Latitude" label-for="v-Latitude">
                    <validation-provider #default="{ errors }"  name="Latitude" rules="required">
                      <b-form-input readonly id="v-Latitude" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Latitude" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Longtitude -->
                <b-col cols="4">
                  <b-form-group label="Longtitude" label-for="v-Longtitude">
                    <validation-provider #default="{ errors }"  name="Longtitude" rules="required">
                      <b-form-input readonly id="v-Longtitude" :state="errors.length > 0 ? false:null" v-model="form.text_4" placeholder="Longtitude" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Device Status -->
                <b-col cols="4">
                  <b-form-group label="Device Status" label-for="v-DeviceStatus">
                    <validation-provider #default="{ errors }"  name="DeviceStatus" rules="required">
                      <b-form-input readonly id="v-DeviceStatus" :state="errors.length > 0 ? false:null" v-model="form.device_status_connection" placeholder="Device Status" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <template v-if="status === 'IN'">
              <b-col cols="12" >
                <b-form-group label="Photo" label-for="v-desc">
                  <br>
                  <b-media no-body>
                    <iframe :src="form.UrlPhoto" width="30%" height="300"/>
                    <b-media-body class="mt-75 ml-75">
                      <!-- upload button -->
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        size="sm"
                        class="mb-75 mr-75"
                        @click="$refs.refInputElPhoto.$el.click()"
                      >
                        Upload
                      </b-button>
                      <b-form-file
                        ref="refInputElPhoto"
                        v-model="form.photo"
                        accept="application/jpg/png/jpeg/JPG/PNG/JPEG"
                        :hidden="true"
                        plain
                        @change="UploadRenderPhoto"
                      />
                      <!--/ upload button -->

                      <!-- reset -->
                      <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        size="sm"
                        class="mb-75 mr-75"
                        @click="resetphoto"
                      >
                        Reset
                      </b-button>
                      <!--/ reset -->
                      <b-card-text>Allowed JPG/jpg/PNG/png. Max size of 2000kB</b-card-text>
                    </b-media-body>
                  </b-media>
                </b-form-group>
              </b-col>
              <b-form @submit.prevent>
                <b-col cols="12">
                  <b-button v-if="checkActionButton('U')" v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="uploadPhoto"> Update </b-button>
                </b-col>
              </b-form>
            </template>
          </b-row>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent>
              <b-col cols="12" v-if="status === 'VF' && checkActionButton('U')">
                <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Approve </b-button> -->
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" v-b-modal.modal-center > Approve </b-button>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="danger" class="mr-1" v-b-modal.modal-center-reject > Reject </b-button>
                <b-link :to="{ path: '/temperature-installation/edit/'+ form.id}"><b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-1" > Edit </b-button></b-link>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="danger" class="mr-1" @click.prevent="validationFormReset"> Reset </b-button>
              </b-col>
            </b-form>
            <b-modal
              id="modal-center"
              ref="my-modal"
              size="lg"
              centered
              title="Notes"
              ok-title="Accept"
              @ok="validationFormNotes()"
            >
              <form ref="form">
                <!-- Reason -->
                <div class="mt-2">
                  <b-form-textarea
                    id="textarea-default"
                    placeholder="Note"
                    v-model="form.textarea_1"
                    rows="3"
                  /><br>
                </div>
              </form>
            </b-modal>
            <b-modal
              id="modal-center-reject"
              ref="my-modal-reject"
              size="lg"
              centered
              title="Reject Notes"
              ok-title="Accept"
              @ok="validationFormReject()"
            >
              <form ref="form">
                <!-- Reason -->
                <div class="mt-2">
                  <b-form-textarea
                    id="textarea-default"
                    placeholder="Note"
                    v-model="form.textarea_1"
                    rows="3"
                  /><br>
                </div>
              </form>
            </b-modal>
          </validation-observer>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="">
          <!-- <b-card-text>Bank.</b-card-text> -->
          <b-row>
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <!-- Instalator Company -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Instalator Company" label-for="v-Instalator Company">
                  <b-form-input  id="v-Instalator Company" v-model="form.text_1" placeholder="Instalator Company" />
              </b-form-group>
            </b-col>
            <!-- Instalator Name -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Instalator Name" label-for="v-Instalator Name">
                  <b-form-input readonly id="v-Instalator Name" v-model="form.text_2" placeholder="Instalator Name" />
              </b-form-group>
            </b-col>
            <!-- Province -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Province" label-for="v-Province">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="ProvinceOptions" :reduce="ProvinceOptions => ProvinceOptions.value"
                    id="v-Province" 
                    v-model="select_6" 
                    label="title"
                    placeholder="--Select Province --"
                    class="w-100"
                    readonly
                  />
              </b-form-group>
            </b-col>
            <!-- Regency -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Regency" label-for="v-Regency">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="RegencyOptions" :reduce="RegencyOptions => RegencyOptions.value"
                    id="v-Regency" 
                    v-model="select_7" 
                    label="title"
                    placeholder="--Select Regency --"
                    class="w-100"
                    readonly
                  />
              </b-form-group>
            </b-col>
            <!-- District -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="District" label-for="v-District">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="DistrictOptions" :reduce="DistrictOptions => DistrictOptions.value"
                    id="v-District" 
                    v-model="select_8" 
                    label="title"
                    placeholder="--Select District --"
                    class="w-100"
                    disabled
                  />
              </b-form-group>
            </b-col>
            <!-- Update Interval -->
            <b-col cols="12" style="display: none;">
              <b-form-group
                label="Update Interval"
              >
              <b-input-group>
                <b-form-input readonly type="number" id="v-Update Interval" v-model="form.text_5" placeholder="Update Interval" />
                <b-input-group-append is-text>
                <b>&nbsp;Minute</b>
                </b-input-group-append>
              </b-input-group>
              </b-form-group>
            </b-col>
            <!-- media -->
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalUrlInstalasi
                variant="outline-primary"
              >
                Installation Documentation File
              </b-button><hr>
              <b-modal
                id="modalUrlInstalasi"
                title="Installation Documentation File"
                size="lg"
                ok-title="Submit"
                cancel-title="Back"
                @ok="uploadInstallationFile('instalasi')"
                @cancel="() => {
                  is_changed = false
                }"
                :ok-disabled="!is_changed"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.UrlInstalasi" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElInstalasi.$el.click()"
                        >
                          {{ form.UrlInstalasi || form.instalasi ? 'Edit': 'Upload'}}
                        </b-button>
                        <b-form-file
                          ref="refInputElInstalasi"
                          v-model="form.instalasi"
                          accept="application/pdf"
                          :hidden="true"
                          plain
                          @change="UploadRenderInstalasi"
                        />
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetinstalasi"
                        >
                          Reset
                        </b-button>
                        <b-card-text>Allowed PDF. Max size of 50000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalUrlBast
                variant="outline-primary"
              >
                BAST File
              </b-button><hr>
              <b-modal
                id="modalUrlBast"
                title="BAST File"
                size="lg"
                ok-title="Submit"
                cancel-title="Back"
                @ok="uploadInstallationFile('bast')"
                @cancel="() => {
                  is_changed = false
                }"
                :ok-disabled="!is_changed"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.UrlBast" width="100%" height="700"/>

                      <b-media-body class="mt-75 ml-75">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElBast.$el.click()"
                        >
                          {{ form.UrlBast || form.bast ? 'Edit': 'Upload'}}
                        </b-button>
                        <b-form-file
                          ref="refInputElBast"
                          v-model="form.bast"
                          accept="application/pdf"
                          :hidden="true"
                          plain
                          @change="UploadRenderBast"
                        />
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetbast"
                        >
                          Reset
                        </b-button>
                        <b-card-text>Allowed PDF. Max size of 50000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalUrlKalibrasi
                variant="outline-primary"
              >
              Device Calibration File
              </b-button><hr>
              <b-modal
                id="modalUrlKalibrasi"
                title="Device Calibration File"
                size="lg"
                ok-title="Submit"
                cancel-title="Back"
                @ok="uploadInstallationFile('kalibrasi')"
                @cancel="() => {
                  is_changed = false
                }"
                :ok-disabled="!is_changed"
              >
                <b-card-text>
                  <b-form-group label="" label-for="v-desc">
                    <br>
                    <b-media no-body>
                      <iframe :src="form.UrlKalibrasi" width="100%" height="700"/>
                      <b-media-body class="mt-75 ml-75">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="$refs.refInputElKalibrasi.$el.click()"
                        >
                          {{ form.UrlKalibrasi || form.kalibrasi ? 'Edit': 'Upload'}}
                        </b-button>
                        <b-form-file
                          ref="refInputElKalibrasi"
                          v-model="form.kalibrasi"
                          accept="application/pdf"
                          :hidden="true"
                          plain
                          @change="UploadRenderKalibrasi"
                        />
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          variant="outline-secondary"
                          size="sm"
                          class="mb-75 mr-75"
                          @click="resetkalibrasi"
                        >
                          Reset
                        </b-button>
                        <b-card-text>Allowed PDF. Max size of 50000kB</b-card-text>
                      </b-media-body>
                    </b-media>
                  </b-form-group>
                </b-card-text>
              </b-modal>
            </b-col>
            <b-col cols="6">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalBastPhoto1
                variant="outline-primary"
              >
              BAST Photo 1
              </b-button>
              <b-modal
                id="modalBastPhoto1"
                title="BAST Photo 1"
                size="lg"
                ok-only
                ok-title="Back"
              >
              <div class="full-screen-image-container">
                <img :src="photo_bast_1" alt="BAST Photo 1" class="full-screen-image" />
              </div>
              </b-modal>
            </b-col>
            <b-col cols="6">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalBastPhoto2
                variant="outline-primary"
              >
              BAST Photo 2
              </b-button>
              <b-modal
                id="modalBastPhoto2"
                title="BAST Photo 2"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_bast_2" alt="BAST Photo 2" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12"><hr></b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto1
                variant="outline-primary"
              >
              FOTO PLANG FASILITAS KESEHATAN
              </b-button><hr>
              <b-modal
                id="modalDocPhoto1"
                title="FOTO PLANG FASILITAS KESEHATAN"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_1" alt="Photo Documentation 1" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto2
                variant="outline-primary"
              >
              FOTO RUANG TEMPAT INSTALASI
              </b-button><hr>
              <b-modal
                id="modalDocPhoto2"
                title="FOTO RUANG TEMPAT INSTALASI"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_2" alt="Photo Documentation 1" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto3
                variant="outline-primary"
              >
              FOTO TEMPAT PENYIMPANAN VAKSIN
              </b-button><hr>
              <b-modal
                id="modalDocPhoto3"
                title="FOTO TEMPAT PENYIMPANAN VAKSIN"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_3" alt="Photo Documentation 3" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto4
                variant="outline-primary"
              >
              FOTO DUS DEVICE
              </b-button><hr>
              <b-modal
                id="modalDocPhoto4"
                title="FOTO DUS DEVICE"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_4" alt="Photo Documentation 4" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto5
                variant="outline-primary"
              >
              FOTO LETAK PENYIMPANAN GLYCOL
              </b-button><hr>
              <b-modal
                id="modalDocPhoto5"
                title="FOTO LETAK PENYIMPANAN GLYCOL"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_5" alt="Photo Documentation 4" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto6
                variant="outline-primary"
              >
              FOTO DEVICE TERPASANG
              </b-button><hr>
              <b-modal
                id="modalDocPhoto6"
                title="FOTO DEVICE TERPASANG"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_6" alt="Photo Documentation 4" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto7
                variant="outline-primary"
              >
              FOTO SERAH TERIMA DUS DEVICE
              </b-button><hr>
              <b-modal
                id="modalDocPhoto7"
                title="FOTO SERAH TERIMA DUS DEVICE"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_7" alt="Photo Documentation 4" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalDocPhoto8
                variant="outline-primary"
              >
              FOTO ANTENA EXTERNAL / SIGNAL DEVICE
              </b-button><hr>
              <b-modal
                id="modalDocPhoto8"
                title="FOTO ANTENA EXTERNAL / SIGNAL DEVICE"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_documentation_8" alt="Photo Documentation 4" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modalPhoto
                variant="outline-primary"
              >
              FOTO SMILE
              </b-button><hr>
              <b-modal
                id="modalPhoto"
                title="FOTO SMILE"
                size="lg"
                ok-only
                ok-title="Back"
              >
                <div class="full-screen-image-container">
                  <img :src="photo_smile" alt="Photo Documentation 4" class="full-screen-image" />
                </div>
              </b-modal>
            </b-col>
            <!--/ media -->
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BInputGroup, BModal, BFormTextarea, BInputGroupAppend, BOverlay, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'
import { mapState } from 'vuex'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
export default {
  components: { vSelect, flatPickr, BInputGroup, BModal, BFormTextarea, BInputGroupAppend, BOverlay, ValidationProvider, ValidationObserver, BCard, BCardText, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '',text_1: '',text_2: '',text_3: '',text_4: '',text_5: '',textarea_1: '',date_1: '', select_9: '', device_status_connection: null,
      UrlInstalasi: '', setUpload: 'none', instalasi: null, 
      UrlBast: '', setUpload2: 'none', bast: null,
      UrlPhoto: '', setUploadP: 'none', photo: null,
      UrlKalibrasi: '', setUpload3: 'none', kalibrasi: null},
      select_6: '',select_7: '',select_8: '',
      device_name:'',
      device_serial_number:'',
      device_note:'',
      area_name:'',
      device_type_name:'',
      installator_name:'',
      location_name:'',
      photo_bast_1:'',
      photo_bast_2:'',
      photo_documentation_1:'',
      photo_documentation_2:'',
      photo_documentation_3:'',
      photo_documentation_4:'',
      photo_documentation_5:'',
      photo_documentation_6:'',
      photo_documentation_7:'',
      photo_documentation_8:'',
      photo_smile:'',
      status:'',
      show: false,
      contentData:null,
      geocoder:'',
      is_changed: false,
      required 
    }
  },
  computed: {
    ...mapState({ 
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province, 
      RegencyOptions: state => state.region.regency, 
      DistrictOptions: state => state.region.district,
      DeviceOptions: state => state.device.options,
      Privileges: state => state.profile.items
    }),
    direction () {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  watch: {
    select_6 (obj) {
      return this.$store.dispatch('region/regency', obj)
    },
    select_7 (obj) {
      return this.$store.dispatch('region/district', obj)
    },
    select_8 (obj) {
      return this.$store.dispatch('site/getByFilter', obj)
    }
  },
  created () {
    this.$store.dispatch('site/getByNonFilter')
    this.$store.dispatch('region/province')
    this.$store.dispatch('device/getDeviceList')
    this.$store.dispatch('profile/getPrivilege')
  },
  methods: {
    initMap(latittute,longtitude) {
      const myLatlng = { lat: latittute, lng: longtitude }
      this.styledMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              { visibility: 'off' }
            ]
          }
        ],
        { name: 'Styled Map' }
      )
      this.map = new window.google.maps.Map(document.getElementById('map'), {
          zoom: 12,
          center: myLatlng,
        }
      )

      const marker = new google.maps.Marker({
          position: myLatlng,
          map: this.map,
          title: `${this.device_name} 
          <hr> Site Name : ${this.device_name} 
          <br> Device Code : ${this.device_name} 
          `,
          optimized: false,
        })

        // // Add a click listener for each marker, and set up the info window.
        marker.addListener('click', () => {
          infoWindow.close()
          infoWindow.setContent(marker.getTitle())
          infoWindow.open(marker.getMap(), marker)
        })

      infoWindow.open(this.map)
      
      // Configure the click listener.
      this.map.addListener('click', (mapsMouseEvent) => {
        // Close the current InfoWindow.
        this.form.text_3 = mapsMouseEvent.latLng.toJSON().lat
        this.form.text_4 = mapsMouseEvent.latLng.toJSON().lng
        infoWindow.close()

        // Create the search box and link it to the UI element.
        const input = document.getElementById("pac-input")
        const searchBox = new google.maps.places.SearchBox(input)

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

        // Bias the SearchBox results towards current map's viewport.
        map.addListener("bounds_changed", () => {
          searchBox.setBounds(map.getBounds())
        });

        // Create a new InfoWindow.
        infoWindow = new google.maps.InfoWindow({
          position: mapsMouseEvent.latLng,
        })
        this.geocoder = new google.maps.Geocoder()
        this.geocoder.geocode({'location': mapsMouseEvent.latLng}, function(results, status) {
          let resultsData = results[0]
          const contentString =
          '<div id="content">' +
          '<div id="siteNotice">' +
          "</div>" +
          '<h1 id="firstHeading" class="firstHeading">'+resultsData.address_components[0].long_name+'</h1>' +
          '<div id="bodyContent">' +
          "<p>"+resultsData.formatted_address+"</p>" +
          "</div>" +
          "</div>"
          // JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2)
          infoWindow.setContent(contentString)
        })
        infoWindow.open(this.map)
      })
      // this.map.mapTypes.set('styled_map', this.styledMapType)
      // this.map.setMapTypeId('styled_map')
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    checkActionButton(action) {
      const privilegeUrl = this.$route.path.split('/')[1];
      const privilege = this.Privileges.find(item => item.url === privilegeUrl)
      if (privilege.privilege_name?.includes(action)) {
        return true
      } else {
        return false
      }
    },
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          this.$bvModal
          .msgBoxConfirm('Apakah anda yakin?', {
            title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
          })
          .then(value => {
            if (value === true){
              const formData = this.form 
              this.$store.dispatch('temperature/formPostPutVerification', formData)
              .then(res => {
                this.notification('Success','CheckIcon','success','You have successfully')
              }, 
              err => {
                this.show = false
                this.notification('Failed','CloseIcon','danger','You have unsuccessful')
              })
            } else {
              this.show = false
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    validationFormNotes () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
          this.$store.dispatch('temperature/formPostPutVerificationNotes', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }).catch(err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger', err.response?.data?.message ?? "You have unsuccessful")
          })
        }else {
          this.show = false
          // this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    uploadPhoto () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
          this.$store.dispatch('temperature/formPostPutConnection', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        }else {
          this.show = false
          // this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    uploadInstallationFile (type) {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = {...this.form, type}
          this.$store.dispatch('temperature/formUploadInstallation', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
            this.show = false
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        }else {
          this.show = false
          // this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
        this.is_changed = false;
      })
    },
    validationFormReset () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          this.$bvModal
          .msgBoxConfirm('Apakah anda yakin?', {
            title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
          })
          .then(value => {
            if (value === true){
              const formData = this.form 
              this.$store.dispatch('temperature/formPostPutVerificationReset', formData)
              .then(res => {
                this.notification('Success','CheckIcon','success','You have successfully')
              }, 
              err => {
                this.show = false
                this.notification('Failed','CloseIcon','danger','You have unsuccessful')
              })
            } else {
              this.show = false
              this.notification('Failed','CloseIcon','danger','You have unsuccessful')
            }
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    validationFormReject () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
          this.$store.dispatch('temperature/formPostPutVerificationReject', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('temperature/getByIdInstallation', id).then(data => {
        this.form.id = id
        this.form.select_1 = data.name
        this.device_name = data.name
        this.form.text_1 = data.device?.installator?.name
        this.form.text_2 = data.device?.installator?.name
        this.form.text_3 = data.latitude
        this.form.text_4 = data.longitude
        this.form.text_5 = data.update_interval
        this.form.date_1 = data.installation_date 
        this.form.device_status_connection = data.device_status
        this.status = data.installation_status 
        this.device_type_name = data.device_types.name
        this.device_note = data.note
        this.device_serial_number = data.serial_number
        this.form.select_9 = data.locations?.areas?.sites?.name
        this.form.UrlInstalasi = data.file_documentation
        this.form.UrlBast = data.file_bast
        this.form.UrlKalibrasi = data.file_calibration
        this.photo_bast_1 = data.photo_bast_1
        this.photo_bast_2 = data.photo_bast_2
        this.photo_documentation_1 = data.photo_documentation_1
        this.photo_documentation_2 = data.photo_documentation_2
        this.photo_documentation_3 = data.photo_documentation_3
        this.photo_documentation_4 = data.photo_documentation_4
        this.photo_documentation_5 = data.photo_documentation_5
        this.photo_documentation_6 = data.photo_documentation_6
        this.photo_documentation_7 = data.photo_documentation_7
        this.photo_documentation_8 = data.photo_documentation_8
        this.photo_smile = data.photo_smile
        this.show = false
        this.initMap(parseFloat(data.latitude), parseFloat(data.longitude))
      })
    },
    reset () {
      this.form.select_1 = ''
      this.form.text_1 = ''
      this.form.text_2 = ''
      this.form.text_3 = ''
      this.form.text_4 = ''
      this.form.text_5 = ''
      this.form.date_1 = '' 
      this.form.select_9 = ''
      this.form.UrlInstalasi = ''
      this.form.UrlBast = ''
      this.form.UrlKalibrasi = ''
    },
    resetinstalasi () {
      this.form.UrlInstalasi = ''
      this.is_changed = false
    },
    resetbast () {
      this.form.UrlBast = ''
      this.is_changed = false
    },
    resetkalibrasi () {
      this.form.UrlKalibrasi = ''
      this.is_changed = false
    },
    UploadRenderInstalasi (e) {
      if (this.form.UrlInstalasi) {
        URL.revokeObjectURL(this.form.UrlInstalasi);
      }
      const instalasi = e.target.files[0];
			this.form.instalasi = instalasi
			this.form.setUpload = 'upload'
			this.form.UrlInstalasi = URL.createObjectURL(e.target.files[0])
      this.is_changed = true;
		},
    UploadRenderBast (e) {
      if (this.form.UrlBast) {
        URL.revokeObjectURL(this.form.UrlBast);
      }
      const bast = e.target.files[0];
			this.form.bast = bast
			this.form.setUpload2 = 'upload'
			this.form.UrlBast = URL.createObjectURL(e.target.files[0])
      this.is_changed = true;
		},
    UploadRenderPhoto (e) {
      if (this.form.UrlPhoto) {
        URL.revokeObjectURL(this.form.UrlPhoto);
      }
      const photo = e.target.files[0];
			this.form.photo = photo
			this.form.setUploadP = 'upload'
			this.form.UrlPhoto = URL.createObjectURL(e.target.files[0])
		},
    UploadRenderKalibrasi (e) {
      if (this.form.UrlKalibrasi) {
        URL.revokeObjectURL(this.form.UrlKalibrasi);
      }
      const kalibrasi = e.target.files[0];
			this.form.kalibrasi = kalibrasi
			this.form.setUpload3 = 'upload'
			this.form.UrlKalibrasi = URL.createObjectURL(e.target.files[0])
      this.is_changed = true;
		}
  },
  mounted () {
    // navigator.geolocation.getCurrentPosition((position) => {
      // this.initMap(position.coords.latitude, position.coords.longitude)
    // })
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style scoped>
  #map {
    height:600px;
    width: 100%;
  }
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style scoped>
.full-screen-image-container {
  position: relative;
  max-width: 100%;
  max-height: 80vh;
  display: flex;
}

.full-screen-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>